import React from 'react';

interface IconProps {
    size?: string | number;
    [key: string]: any;
}

const CircleImage = ({size = 16, ...rest}: IconProps) => {
    return (
        <svg
            fill="currentColor"
            viewBox="0 0 14 14"
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            {...rest}
        >
            <path d="M7 13.125C3.61726 13.125 0.875 10.3827 0.875 7C0.875 3.61726 3.61726 0.875 7 0.875C10.3827 0.875 13.125 3.61726 13.125 7C13.125 10.3827 10.3827 13.125 7 13.125ZM7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z" fill="currentColor" />
            <path d="M6.25146 4.8125C6.25146 5.53737 5.66384 6.125 4.93896 6.125C4.21409 6.125 3.62646 5.53737 3.62646 4.8125C3.62646 4.08763 4.21409 3.5 4.93896 3.5C5.66384 3.5 6.25146 4.08763 6.25146 4.8125Z" fill="currentColor" />
            <path d="M3.49727 12.4977L2.00151 11.1682L4.0808 7.96592C4.21322 7.81156 4.42069 7.78761 4.5765 7.9087L6.66561 9.53223L9.58065 6.13414C9.70022 5.99476 9.88288 5.96021 10.0341 6.04836L13 8.87779L12.4998 10.5L10.9998 12L9.49981 13L6.99981 13.5L3.49981 12.5L3.49727 12.4977Z" fill="currentColor" />
         </svg>
    );
};

export default CircleImage;